import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import {
  clearChecklistDailyCurrentErrors,
  clearChecklistResults,
  listChecklistResults,
  setChecklistDailyCurrentErrors,
  setChecklistDailyCurrentField,
  updateChecklistResults
} from '../actions/checklist'
import { createDefect } from '../actions/defect'
import { clearFile, setFiles } from '../actions/file'
import { clearUserKey, listUsers, setUserIsLoading, setUserSelected } from '../actions/user'

import ChecklistDaily from '../components/ChecklistDaily'

class ChecklistDailyPage extends React.Component {
  async componentDidMount () {
    const { clearChecklistResults, listChecklistResults, match } = this.props
    await clearChecklistResults()
    listChecklistResults(match.params.id)
  }

  render () {
    return (<ChecklistDaily {...this.props}/>)
  }
}

const selector = formValueSelector('checklist-daily')

const mapStateToProps = (state, ownProps) => {
  const { checklist } = state
  const current = _.get(checklist, 'results.current', {})
  const list = _.get(checklist, 'results.list')
  const projectId = _.get(checklist, 'results.projectId')
  const props = {
    list,
    projectId,
    defectAddErrors: current.defectAddErrors || {},
    authorUserId: state.auth.id,
    defectAreaId: current.defectAreaId,
    expectedDeliveryDate: current.expectedDeliveryDate,
    assignee: state.user.assignee || { isLoading: false, list: { rows: [] }, selected: [], defaultSelected: [] },
    images: state.file['checklist-daily-defect-add'],
    imageData: state.file['checklist-daily-defect-add-data'],
  }
  if (list) {
    props.initialValues = _.reduce(list, (initialValues, row) => {
      initialValues[`result-${row.id}`] = row.result
      return initialValues
    }, {})
    props.results = _.reduce(list, (results, row) => {
      results[`result-${row.id}`] = selector(state, `result-${row.id}`)
      return results
    }, {})
  }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit (values) {
    const list = []
    _.forEach(values, (value, key) => {
      list.push({
        id: key.replace('result-', ''),
        result: value,
      })
    })
    await dispatch(updateChecklistResults(list))
    dispatch(push('/checklist'))
  },
  clearChecklistResults () {
    dispatch(clearChecklistResults())
  },
  listChecklistResults (checklistId) {
    dispatch(listChecklistResults(checklistId, moment().format('YYYY-MM-DD')))
  },
  async onDefectAddSubmit (values, assignee, images) {
    const errors = {}
    if (!assignee) {
      errors.assignee = 'Assignee is required.'
    }
    if (!values.detail) {
      errors.detail = 'Detail is required.'
    }
    if (!values.expectedDeliveryDate || !values.expectedDeliveryDate.isValid()) {
      errors.expectedDeliveryDate = 'Expected Delivery Date is required.'
    }
    if (!_.isEmpty(errors)) {
      dispatch(setChecklistDailyCurrentErrors(errors))
      return
    }
    dispatch(clearChecklistDailyCurrentErrors())
    await dispatch(createDefect({
      ...values,
      assigneeUserId: assignee.id,
      status: 'OPEN',
      source: 'CHECKLIST'
    }, images))
    dispatch(setChecklistDailyCurrentField('defectAreaId', undefined))
  },
  setChecklistDailyCurrentField (field, value) {
    if (field === 'defectAreaId') {
      dispatch(clearChecklistDailyCurrentErrors())
      dispatch(clearUserKey('assigneeUser'))
      dispatch(clearFile('checklist-daily-defect-add'))
      dispatch(clearFile('checklist-daily-defect-add-data'))
    }
    dispatch(setChecklistDailyCurrentField(field, value ? value : undefined))
  },
  async searchUser (name, key) {
    dispatch(setUserIsLoading(true, key))
    await dispatch(listUsers({ name }, key))
    dispatch(setUserIsLoading(false, key))
  },
  setUserSelected (selected, key) {
    dispatch(setUserSelected(selected, key))
  },
  uploadImage (event) {
    const { files } = event.target
    dispatch(setFiles('checklist-daily-defect-add', files))
    _.forEach(files, (file) => {
      const reader = new FileReader()
      reader.onloadend = (event) => {
        dispatch(setFiles('checklist-daily-defect-add-data', [event.target.result]))
      }
      reader.readAsDataURL(file)
    })
  },
  goBack () {
    dispatch(goBack())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistDailyPage)


// WEBPACK FOOTER //
// ./src/containers/ChecklistDailyPage.js